import Vue from "vue";

// Import models
import { Tag } from "@/models/tag.model";

const reinitializeModules = () => {
  setTimeout(() => {
    Miele.ModuleLoader.initializeDataLoadModules();
    const body = document.body;
    body.classList.remove("loading");
  }, 800);
};

const mutations = {
  SET_RECIPES(state: any, recipes: any) {
    state.recipes = recipes;
    reinitializeModules();
  },
  SET_SINGLE_RECIPE(state: any, recipe: any) {
    state.currentRecipe = recipe;
  },
  SET_SLIDES(state: any, slides: any) {
    state.slides = slides;
  },
  APPEND_RECIPES(state: any, recipes: any) {
    state.recipes.data = [...state.recipes.data, ...recipes.data];
    state.recipes.meta = recipes.meta;
    reinitializeModules();
  },
  SET_GROUPS(state: any, groups: any) {
    state.groups = groups;
  },
  SET_TAGS(state: any, tags: Array<Tag>) {
    Vue.set(state.searchParams, "tags", [...tags]);
  },
  REMOVE_TAG(state: any, tag: Tag) {
    state.searchParams.tags =
      state.searchParams.tags.filter((t: any) => t.id !== tag.id) || [];
  },
  SET_SEARCH(state: any, searchValue: string) {
    state.searchParams.search = searchValue;
  },
  LOAD_MORE(state: any) {
    state.searchParams.page++;
  },
  RESET_TAGS(state: any) {
    Vue.set(state.searchParams, "tags", [...[]]);
  },
  RESET_PAGE(state: any) {
    state.searchParams.page = 1;
  },
  REMOVE_LOADER(state: any) {
    state.loading = false;
  },
  ADD_LOADER(state: any) {
    state.loading = true;
  },
};

export default mutations;
